import { useMutation } from "@tanstack/react-query";
import { api } from "../api";
import type { PaymentSelection } from "../api";

export function useConfirmPaymentMethod() {
  return useMutation({
    mutationFn: ({
      userId,
      setupIntentId,
      promoCode,
      planId,
      selections,
    }: {
      userId: string;
      setupIntentId: string;
      promoCode?: string;
      planId?: string;
      selections?: PaymentSelection[];
    }) =>
      api
        .confirmPaymentMethod(userId, setupIntentId, promoCode, planId, selections)
        .then((r) => r.data),
  });
}
